module.exports = __webpack_public_path__ + "static/media/NewStandard.59d42829.png";